import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hrDepartmentsAction } from '../actions/hrActions'
import Notification from '../components/Notification'
import Progress from '../components/Progress'
import Controls from '../components/controls/Controls'
import Popup from '../components/Popup'
import AddDepartment from '../components/AddDepartment'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import PageHeader from '../components/PageHeader'
import PeopleOutlineTwoToneIcon from '@material-ui/icons/PeopleOutlineTwoTone'
import MaterialTable from 'material-table'

const HRDepartments = ({ history }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })

  const dispatch = useDispatch()
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const hrDpts = useSelector((state) => state.hrDpts)
  const { loading, error, hrDepartments } = hrDpts

  useEffect(() => {
    if (!userInfo) {
      history.push('/')
    }
  }, [dispatch, history, userInfo])

  const [masterDepartments, setMasterDepartments] = useState([])
  const [departments, setDepartments] = useState([])
  const [employees, setEmployees] = useState([])

  useEffect(() => {
    dispatch(hrDepartmentsAction())
  }, [])

  useEffect(() => {
    if (hrDepartments) {
      if (hrDepartments.role === 'Admin' || hrDepartments.role === 'HR') {
        setMasterDepartments(hrDepartments.masterDepartments)
        setDepartments(hrDepartments.departments)
        setEmployees(hrDepartments.employees)
      } else {
        history.push('/dashboard')
      }
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        type: 'error',
      })
    }
  }, [hrDepartments, error])

  const [openPopup, setOpenPopup] = useState(false)
  const [departmentForEdit, setDepartmentForEdit] = useState(null)

  const openInPopup = (item) => {
    setDepartmentForEdit(item)
    setOpenPopup(true)
  }

  const openAdd = () => {
    setDepartmentForEdit(null)
    setOpenPopup(true)
  }

  // Table
  const headCells = [
    {
      field: 'master_department_name',
      title: 'Master Department',
    },
    {
      field: 'name',
      title: 'Name',
    },
    {
      field: 'type',
      title: 'Type',
    },
    {
      field: 'category',
      title: 'Category',
    },
    {
      field: 'security',
      title: 'Security',
    },
    {
      field: 'product',
      title: 'Product',
    },
    {
      field: 'bankType',
      title: 'Bank Type',
    },
    {
      field: 'addedOn',
      title: 'Added On',
    },
    {
      field: 'actions',
      title: 'Actions',
      render: (rowData) => (
        <Controls.ActionButton color='primary'>
          <EditOutlinedIcon
            fontSize='small'
            onClick={() => openInPopup(rowData)}
          />
        </Controls.ActionButton>
      ),
    },
  ]

  return (
    <>
      {loading ? (
        <Progress />
      ) : (
        <>
          {error ? (
            <Notification notify={notify} setNotify={setNotify} />
          ) : (
            <>
              <PageHeader
                title='Departments'
                subtitle='Shows list of departments in the organisations'
                icon={<PeopleOutlineTwoToneIcon fontSize='medium' />}
              />
              <MaterialTable
                style={{ margin: '0 20px' }}
                title='Departments'
                columns={headCells}
                data={departments}
                options={{
                  exportButton: true,
                  search: true,
                  exportAllData: true,
                }}
                actions={[
                  {
                    icon: 'add',
                    tooltip: 'Add Department',
                    isFreeAction: true,
                    onClick: () => openAdd(),
                  },
                ]}
              />
              <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Add Department'
              >
                <AddDepartment
                  departmentForEdit={departmentForEdit}
                  masterDepartments={masterDepartments}
                  employees={employees}
                  setOpenPopup={setOpenPopup}
                />
              </Popup>
            </>
          )}
        </>
      )}
    </>
  )
}

export default HRDepartments
